/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useEffect, useState} from 'react';
import moment from 'moment';
import { IdleTimeOutModal } from './IdleTimeOutModal';
import { IDLE_URL } from "../../constants/URL";

const IdleTimeOutHandler = (props)=>{
    const[showModal,setShowModal]=useState(false)
    const[isLogout,setLogout]=useState(false)
    const [redirectTimeout, setRedirectTimeout] = useState(null);
    let timer=undefined;
    const events= ['click','scroll','load','keydown']
    const eventHandler =(eventType)=>{
        if(!isLogout){
            localStorage.setItem('lastInteractionTime',moment() )
            if(timer){
                props.onActive();
                startTimer();
            }
        }

    };

    useEffect(()=>{
        addEvents();
        return (()=>{
            removeEvents();
            clearTimeout(timer);
            clearTimeout(redirectTimeout);
        })
    },[])

    const startTimer=()=>{

        if(timer){
            clearTimeout(timer)
        }
        timer=setTimeout(()=>{

            const lastInteractionTime=localStorage.getItem('lastInteractionTime')
            const diff = moment.duration(moment().diff(moment(lastInteractionTime)));
            const timeOutInterval=props.timeOutInterval?props.timeOutInterval:120000;
            if(isLogout){
                clearTimeout(timer)
            }else{
                if(diff._milliseconds<timeOutInterval){
                    startTimer();
                    props.onActive();
                }else{
                    props.onIdle();
                    setShowModal(true)
                    setRedirectTimeout(
                        setTimeout(() => {
                            window.location.replace(IDLE_URL);
                        }, 30000));
                }
            }

        },props.timeOutInterval?props.timeOutInterval:120000)
    }
    const addEvents=()=>{

        events.forEach(eventName=>{
            window.addEventListener(eventName,eventHandler)
        })

        startTimer();
    }

    const removeEvents=()=>{
        events.forEach(eventName=>{
            window.removeEventListener(eventName,eventHandler)
        })
    };

    const handleContinueSession = ()=>{
        setShowModal(false)
        setLogout(false)
        clearTimeout(redirectTimeout);
    }
    const handleLogout = ()=>{
        removeEvents();
        clearTimeout(timer);
        clearTimeout(redirectTimeout);
        setLogout(true)
        props.onLogout();
        setShowModal(false)

    }

    return(
        <div>

        <IdleTimeOutModal
        showModal={showModal}
        handleContinue={handleContinueSession}
        handleLogout={handleLogout}
        />

        </div>
        )

    }

    export default IdleTimeOutHandler;